var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3587_7509)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3587_7509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.084 18.9987H16.9173C16.7626 18.9987 16.6142 18.9372 16.5048 18.8278C16.3954 18.7184 16.334 18.5701 16.334 18.4154C16.334 18.2606 16.3954 18.1123 16.5048 18.0029C16.6142 17.8935 16.7626 17.832 16.9173 17.832H18.084C18.5481 17.832 18.9932 17.6477 19.3214 17.3195C19.6496 16.9913 19.834 16.5462 19.834 16.082V14.9154C19.834 14.7607 19.8954 14.6123 20.0048 14.5029C20.1142 14.3935 20.2626 14.332 20.4173 14.332C20.572 14.332 20.7204 14.3935 20.8298 14.5029C20.9392 14.6123 21.0006 14.7607 21.0006 14.9154V16.082C20.9997 16.8553 20.6921 17.5966 20.1453 18.1434C19.5986 18.6902 18.8572 18.9978 18.084 18.9987Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58333 9.66667C7.42862 9.66667 7.28025 9.60521 7.17085 9.49581C7.06146 9.38642 7 9.23804 7 9.08333V7.91667C7.00093 7.1434 7.30851 6.40208 7.85529 5.85529C8.40208 5.30851 9.1434 5.00093 9.91667 5H11.0833C11.238 5 11.3864 5.06146 11.4958 5.17085C11.6052 5.28025 11.6667 5.42862 11.6667 5.58333C11.6667 5.73804 11.6052 5.88642 11.4958 5.99581C11.3864 6.10521 11.238 6.16667 11.0833 6.16667H9.91667C9.45254 6.16667 9.00742 6.35104 8.67923 6.67923C8.35104 7.00742 8.16667 7.45254 8.16667 7.91667V9.08333C8.16667 9.23804 8.10521 9.38642 7.99581 9.49581C7.88642 9.60521 7.73804 9.66667 7.58333 9.66667Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 18.9987H9.91667C9.1434 18.9978 8.40208 18.6902 7.85529 18.1434C7.30851 17.5966 7.00093 16.8553 7 16.082V14.9154C7 14.7607 7.06146 14.6123 7.17085 14.5029C7.28025 14.3935 7.42862 14.332 7.58333 14.332C7.73804 14.332 7.88642 14.3935 7.99581 14.5029C8.10521 14.6123 8.16667 14.7607 8.16667 14.9154V16.082C8.16667 16.5462 8.35104 16.9913 8.67923 17.3195C9.00742 17.6477 9.45254 17.832 9.91667 17.832H11.0833C11.238 17.832 11.3864 17.8935 11.4958 18.0029C11.6052 18.1123 11.6667 18.2606 11.6667 18.4154C11.6667 18.5701 11.6052 18.7184 11.4958 18.8278C11.3864 18.9372 11.238 18.9987 11.0833 18.9987Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4173 9.66667C20.2626 9.66667 20.1142 9.60521 20.0048 9.49581C19.8954 9.38642 19.834 9.23804 19.834 9.08333V7.91667C19.834 7.45254 19.6496 7.00742 19.3214 6.67923C18.9932 6.35104 18.5481 6.16667 18.084 6.16667H16.9173C16.7626 6.16667 16.6142 6.10521 16.5048 5.99581C16.3954 5.88642 16.334 5.73804 16.334 5.58333C16.334 5.42862 16.3954 5.28025 16.5048 5.17085C16.6142 5.06146 16.7626 5 16.9173 5H18.084C18.8572 5.00093 19.5986 5.30851 20.1453 5.85529C20.6921 6.40208 20.9997 7.1434 21.0006 7.91667V9.08333C21.0006 9.23804 20.9392 9.38642 20.8298 9.49581C20.7204 9.60521 20.572 9.66667 20.4173 9.66667Z",
    fill: "#5C5C5C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3587_7509",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3587_7509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3587_7509",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3587_7509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(7 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomImg);
export default __webpack_public_path__ + "static/media/zoomImg.60bd2ce4.svg";
export { ForwardRef as ReactComponent };